import { render, staticRenderFns } from "./Dashboard_Sales_Summary.new.vue?vue&type=template&id=c203e5a8&scoped=true&"
import script from "./Dashboard_Sales_Summary.new.vue?vue&type=script&lang=js&"
export * from "./Dashboard_Sales_Summary.new.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_Sales_Summary.new.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Dashboard_Sales_Summary.new.vue?vue&type=style&index=1&id=c203e5a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c203e5a8",
  null
  
)

export default component.exports